module.exports = __webpack_public_path__ + "img/yellow-flight.d6f7a8ef.svg";